var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50003 11H2.50003V18C2.50003 19.103 3.39703 20 4.50003 20H16.5C17.603 20 18.5 19.103 18.5 18V11H19.5C19.6978 10.9999 19.8911 10.9413 20.0555 10.8314C20.2199 10.7215 20.348 10.5653 20.4237 10.3826C20.4994 10.1999 20.5192 9.99891 20.4806 9.80496C20.442 9.611 20.3468 9.43284 20.207 9.29299L11.207 0.292987C11.1142 0.200042 11.004 0.126304 10.8827 0.0759932C10.7614 0.0256825 10.6314 -0.000213623 10.5 -0.000213623C10.3687 -0.000213623 10.2387 0.0256825 10.1173 0.0759932C9.99602 0.126304 9.88582 0.200042 9.79303 0.292987L0.793031 9.29299C0.653222 9.43284 0.558015 9.611 0.519448 9.80496C0.48088 9.99891 0.500683 10.1999 0.576353 10.3826C0.652023 10.5653 0.780163 10.7215 0.944573 10.8314C1.10898 10.9413 1.30228 10.9999 1.50003 11ZM8.50003 18V13H12.5V18H8.50003ZM10.5 2.41399L16.5 8.41399V13L16.501 18H14.5V13C14.5 11.897 13.603 11 12.5 11H8.50003C7.39703 11 6.50003 11.897 6.50003 13V18H4.50003V8.41399L10.5 2.41399Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.27b2d43a17bbf77506dc80974c0c42bf.svg";
export { ForwardRef as ReactComponent };